import { type FC } from 'react'
import { Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import { SCORE_BENCHMARK } from '../scoreRoster'
import { type ScoreResultMeetingRef } from '../../../shared/insights/store/insights'
import { formatShortDateWithYear } from '../../../common/dateUtils'
import styles from './TopMeetingsCard.module.scss'

interface TopMeetingsCardProps {
  meetings: ScoreResultMeetingRef[]
  canViewMeetings: boolean
}

export const TopMeetingsCard: FC<TopMeetingsCardProps> = ({ meetings, canViewMeetings }) => (
  <Card className='zocks-border-color-gray-200 zocks-border-0.75'>
    <Card.Body className='d-flex flex-column p-4 zocks-gap-1'>
      <div className='d-flex flex-column'>
        <h5 className='insights-section-title mb-0'>Top meetings</h5>
        <p className='insights-section-subtitle mb-0'>Highest scoring meetings in the period.</p>
      </div>
      <div className='d-flex flex-column'>
        {meetings.map((meeting) => (
          <div key={`${meeting.room_id}-${meeting.session_id}`} className={classNames('d-flex align-items-center gap-3 zocks-py-0.75', styles.meetingRow)}>
            <span className={classNames('paragraph-small bold zocks-text-gray-600 text-uppercase flex-shrink-0', styles.tabularNums, styles.meetingDate)}>
              {formatShortDateWithYear(new Date(meeting.date))}
            </span>
            <span className={classNames('paragraph-small zocks-text-gray-900 flex-grow-1 mw-0 text-truncate', styles.meetingRowLink)}>{meeting.title}</span>
            <span
              className={classNames(
                'paragraph-small bold rounded-1 zocks-px-0.25 zocks-py-0.125 flex-shrink-0',
                styles.tabularNums,
                meeting.score >= SCORE_BENCHMARK ? 'zocks-text-success-200 zocks-bg-color-success-background' : 'zocks-text-gray-900 zocks-bg-color-warning',
              )}
            >
              {Math.round(meeting.score)}
            </span>
            {canViewMeetings ? (
              <Link
                to={`/workspace/past-meetings/room/${meeting.room_id}/session/${meeting.session_id}/`}
                className={classNames('paragraph-small zocks-text-gray-900 text-decoration-none flex-shrink-0', styles.meetingRowLink)}
                aria-label={`View meeting ${meeting.title}`}
              >
                →
              </Link>
            ) : null}
          </div>
        ))}
      </div>
    </Card.Body>
  </Card>
)
